import React, {memo} from "react";
import {Col, Modal, Row} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import swal from 'sweetalert';
import {handelCloseModalSelectBaseMarket} from "../../../../../redux/actions/modals/modalSelectBaseMarket";
import TitlesModals from "../TitlesModals";
import {ICONS_PUBLIC_URL_SERVER, PUBLIC_URL_SERVER} from "../../../../../apis";
import {LazyLoadImage} from "react-lazy-load-image-component";
import imgPlayS from "../../../../../images/base-image-product.jpg";
import BoxClickChangeAddress from "../Address/BoxClickChangeAddress";
import {actionRefreshModalShoppingCard} from "../../../../../redux/actions/modals/modalShoppingCard";
import {useHistory} from "react-router-dom";
import {FaAngleRight, FaStore} from "react-icons/all";
import Swal from 'sweetalert2';

const ModalSelectBaseMarket = () => {
    let history = useHistory();
    const dispatch = useDispatch();
    const {statusShow, origin} = useSelector(state => state.modalSelectBaseMarket);
    const {list_stores} = useSelector(state => state.stores);
    const {carts, storeSelected} = useSelector(state => state.shoppingCart);
    const handleClose = () => {
        dispatch(handelCloseModalSelectBaseMarket());
    };

    const handleSelectMarket = (data) => {
        if ((storeSelected && storeSelected.id !== data.id) && carts.length > 0) {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                    cancelButton: 'base-btn-green-border btn btn-success',
                },
                buttonsStyling: false
            });
            swalWithBootstrapButtons.fire({
                text: 'سفارش از هر فروشگاه جداگانه ثبت می شود. با تغییر فروشگاه سبد خرید شما خالی می شود. آیا مایل به تغییر فروشگاه هستید؟',
                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                imageHeight: 45,
                imageAlt: 'فروت مروت',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(actionRefreshModalShoppingCard());
                    history.push(`/stores/${data.id}`);
                    handleClose();
                }
            });

            // swal({
            //     title: "توجه",
            //     text: 'سفارش از هر فروشگاه جداگانه ثبت می شود. با تغییر فروشگاه سبد خرید شما خالی می شود. آیا مایل به تغییر فروشگاه هستید؟',
            //     buttons: {
            //         cancel: "انصراف",
            //         confirm: {
            //             text: 'بله',
            //             value: "ok",
            //         },
            //     },
            //     icon: "warning",
            // }).then((value) => {
            //     if (value === 'ok') {
            //         dispatch(actionRefreshModalShoppingCard());
            //         history.push(`/stores/${data.id}`);
            //         handleClose();
            //     }
            // });
        } else {
            history.push(`/stores/${data.id}`);
            handleClose();
        }
    };

    const handelAlertSelectMarket = () => {
        swal({
            title: "انتخاب فروشگاه",
            text: "لطفا فروشگاهی که قصد خرید از آن دارید را انتخاب کنید.",
            buttons: {
                cancel: "تایید",
            },
            icon: "warning",
        });
    };

    return (
        <BaseModal title={'انتخاب فروشگاه'}
                   show={statusShow}
                   dialogClassName={''}
                   handleClose={origin === 'start-app' ? handelAlertSelectMarket : handleClose}>
            <Modal.Body>
                <BoxClickChangeAddress data={{destination: 'MODAL_CHANGE_SELECT_SHOPPING'}}/>
                <TitlesModals>
                    <FaStore className={'mr-2'}/>
                    <span>فروشگاه مورد نظر را انتخاب کنید</span>
                </TitlesModals>
                <div>
                    <ul className={'list-show-select-base-market'}>
                        {list_stores.length !== 0 ? list_stores.map(market => {
                            return (
                                <li key={market.id}
                                    className={`item-show-select-base-market`}
                                    onClick={() => handleSelectMarket(market)}>
                                    <Row className='w-100 m-0'>
                                        <Col xs={1}>
                                            <FaAngleRight className={'icon-angle-right-item-select-base-market'}/>
                                        </Col>
                                        <Col xs={8}>
                                            <h6 className={'title-txt-item-select-base-market'}>{market.title}</h6>
                                            <p className={'body-txt-item-select-base-market m-0'}>{market.sub_title}</p>
                                            <p className={'time-send-item-select-base-market m-0'}>{market.first_delivery_time}</p>
                                        </Col>
                                        <Col xs={3} className='text-center'>
                                            <LazyLoadImage
                                                alt={market.title}
                                                src={PUBLIC_URL_SERVER + ICONS_PUBLIC_URL_SERVER + market.icon}
                                                width={60}
                                                height={60}
                                                placeholderSrc={imgPlayS}
                                            />
                                        </Col>
                                    </Row>
                                </li>
                            )
                        }) : <div className={'text-center'}>فروشگاهی یافت نشد</div>}
                    </ul>
                </div>
            </Modal.Body>
        </BaseModal>
    );
};

export default memo(ModalSelectBaseMarket);
